<template>
  <button
    :class="[
      'btn',
      {
        primaryBtn: stylevariant === 'primary',
        secondaryBtn: stylevariant === 'secondary',
        linkBtn: stylevariant === 'link',
        hardLink: stylevariant === 'hardlink'
      },
      {'nofocus' : !focusable },
    ]"
    :type="type"
    :disabled="disabled"
    @click="click"
    :style="cus_style"
  >
    <slot></slot>
    <base-spinner size="small" v-if="loading" style="margin-left: 0.5rem"></base-spinner>
  </button>
</template>

<script>
export default {
  emits: ["click"],
  props: ["type", "disabled", "stylevariant", "cus_style", "loading", 'focusable'],
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
@import './BaseButton.scss';
</style>
